@if (currentNotification) {
  <oui-banner
    title="Une ou plusieurs demandes de création de personne morale ont été validées"
    declination="alert"
    [action]="action"
  [showCloseButton]="false"></oui-banner>
}
